import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { ACTION_TYPES, WalletAccountState } from './WalletAccount.type';

const initialState: WalletAccountState = {
    address: '',
    token: '',
    segWitAddress: '',
    tapRootAddress: '',
    satoshiAmount: 0,
    signature: '',
    nonce: 0,
    codeError: 0,
};

const walletAccountReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ACTION_TYPES.ACTION_UPDATE_ACCESS_TOKEN: {
            const { address, token, segWitAddress, tapRootAddress, signature, satoshiAmount, nonce } = action.payload;
            return {
                ...state,
                address,
                token,
                segWitAddress,
                tapRootAddress,
                signature,
                nonce,
                satoshiAmount,
            };
        }
        case ACTION_TYPES.ACTION_UPDATE_CODE_ERROR: {
            const { statusCode } = action.payload;
            return {
                ...state,
                codeError: statusCode,
            };
        }
        default:
            return state;
    }
};

const persistConfig = {
    key: 'walletAccount',
    storage,
    whitelist: ['address', 'token', 'segWitAddress', 'tapRootAddress', 'signature', 'nonce'],
    stateReconciler: autoMergeLevel2,
};

export default persistReducer(persistConfig, walletAccountReducer as any);
